import * as React from 'react';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { SectionImage } from '../../uiComponents/layout/SectionImage';
import { Clearfix } from '../../uiComponents/layout/Clearfix';
import KonkurrenceOpgaveAfsnit from './KonkurrenceOpgaveAfsnit';
import KonkurrenceOpgaveDelopgave from './KonkurrenceOpgaveDelopgave';
import { Opgave } from '../../models/Opgave';
import { KonkurrencestatusEnum } from '../../models/enums/KonkurrencestatusEnum';

export interface KonkurrenceOpgavePresenterProps {
    opgave: Opgave;
    konkurrenceId: string;
    konkurrenceDag?: Date | undefined;
    konkurrenceStatus?: KonkurrencestatusEnum;
    readonly?: boolean;
}

export default class KonkurrenceOpgavePresenter extends React.Component<KonkurrenceOpgavePresenterProps, any> {
    constructor(props: KonkurrenceOpgavePresenterProps) {
        super(props);

        this.getAfsnit = this.getAfsnit.bind(this);
        this.getDelopgaver = this.getDelopgaver.bind(this);
    }

    getAfsnit() {
        if (this.props.opgave.opgaveAfsnit === undefined) {
            return [];
        } else {
            return this.props.opgave.opgaveAfsnit.map((k, i) => {
                return <KonkurrenceOpgaveAfsnit key={i} afsnit={k} />;
            });
        }
    }

    getDelopgaver() {
        if (this.props.opgave.delopgaver === undefined) {
            return [];
        } else {
            let i = 0;
            return this.props.opgave.delopgaver.map((k) => {
                i++;
                return (
                <KonkurrenceOpgaveDelopgave 
                    key={k.id} 
                    index={i} 
                    delopgave={k} 
                    opgaveId={this.props.opgave.id} 
                    konkurrenceId={this.props.konkurrenceId} 
                    konkurrenceDag={this.props.konkurrenceDag}
                    konkurrenceStatus={this.props.konkurrenceStatus}
                    readonly={this.props.readonly}
                />
                );
            });
        }
    }

    render() {
        return (
            <div>
                <SectionGroup >
                    <SectionImage blobId={this.props.opgave.billedId} />
                    <Clearfix />
                    {this.getAfsnit()}
                    <Clearfix />
                </SectionGroup>
                {this.getDelopgaver()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceOpgavePresenter.tsx